export const SHIPMENT_FLOW_TRIGGER_IDS = [5, 6, 7, 8, 9];